import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';

import { makeStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';

import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles(theme => ({
    closeButton: {
        color: theme.palette.text.primary,
    },
    '@keyframes notify': {
        '0%': { boxShadow: `0px 0px 10px -5px ${theme.palette.primary.main}` },
        '50%': { boxShadow: `0px 0px 30px -5px ${theme.palette.primary.main}` },
        '100%': { boxShadow: `0px 0px 10px -5px ${theme.palette.primary.main}` },
    },
    '@keyframes notify-success': {
        '0%': { boxShadow: `0px 0px 10px -5px ${theme.palette.success.main}` },
        '50%': { boxShadow: `0px 0px 30px -5px ${theme.palette.success.main}` },
        '100%': { boxShadow: `0px 0px 10px -5px ${theme.palette.success.main}` },
    },
    '@keyframes notify-warning': {
        '0%': { boxShadow: `0px 0px 10px -5px ${theme.palette.warning.main}` },
        '50%': { boxShadow: `0px 0px 30px -5px ${theme.palette.warning.main}` },
        '100%': { boxShadow: `0px 0px 10px -5px ${theme.palette.warning.main}` },
    },
    '@keyframes notify-error': {
        '0%': { boxShadow: `0px 0px 10px -5px ${theme.palette.error.main}` },
        '50%': { boxShadow: `0px 0px 30px -5px ${theme.palette.error.main}` },
        '100%': { boxShadow: `0px 0px 10px -5px ${theme.palette.error.main}` },
    },
    '@keyframes Toastify__trackProgress': {
        '0%': { transform: 'scaleX(1)' },
        '100%': { transform: 'scaleX(0)' },
    },
    toastNotes: {
        '&': {
            marginTop: '75px',
            width: 'auto',
        },
        '& .Toastify__toast': {
            background: theme.styled.paper.background,
            color: theme.palette.text.primary,
            borderSize: '1px',
            borderStyle: 'solid',
            alignItems: 'center',
        },
        '& .Toastify__toast--default': {
            borderColor: theme.palette.primary.dark,
            // animation: '$notify 3s 2',
            '& .Toastify__progress-bar': {
                background: theme.palette.secondary.main,
            },
        },
        '& .Toastify__toast--success': {
            borderColor: theme.palette.success.dark,
            // animation: '$notify-success 3s 2',
            '& .Toastify__progress-bar': {
                background: theme.palette.success.main,
            },
        },
        '& .Toastify__toast--warning': {
            borderColor: theme.palette.warning.dark,
            // animation: '$notify-warning 3s 2',
            '& .Toastify__progress-bar': {
                background: theme.palette.warning.main,
            },
        },
        '& .Toastify__toast--error': {
            borderColor: theme.palette.error.dark,
            // animation: '$notify-error 3s 2',
            '& .Toastify__progress-bar': {
                background: theme.palette.error.main,
            },
        },
        '& .Toastify__toast--info': {
            borderColor: theme.palette.primary.dark,
            // animation: '$notify 3s 2',
            '& .Toastify__progress-bar': {
                background: theme.palette.secondary.main,
            },
        },
        // '& .Toastify__progress-bar': {
        //     position: 'absolute',
        //     bottom: 0,
        //     left: 0,
        //     width: '100%',
        //     height: '5px',
        //     // zIndex: 'var(--toastify-z-index)',
        //     opacity: '0.7',
        //     transformOrigin: 'left',
        // },
        // '& .Toastify__progress-bar--animated': {
        //     animation: '$Toastify__trackProgress linear 1s forwards',
        // },
    }
}));

const CloseButton = ({ closeToast }) => {
    const classes = useStyles();
    return (
        <IconButton
            className={classes.closeButton}
            aria-label="close"
            onClick={closeToast}
            size="large"><CloseIcon /></IconButton>
    );
};

CloseButton.propTypes = {
    closeToast: PropTypes.func,
};

const Notifications = () => {
    const classes = useStyles();
    return (
        <ToastContainer
            className={classes.toastNotes}
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            closeOnClick={false}
            closeButton={<CloseButton />}
            pauseOnFocusLoss={false}
            draggable={false}
        />
    );
};

export default Notifications;
